/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCommonAirTrack = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m10.422 14.752-8.647 2.386-.005-1.574 8.638-5.532-.014-4.72c-.003-1.082.778-3.15 1.565-3.152s1.579 2.06 1.582 3.143l.014 4.72 8.67 5.481.005 1.574-8.661-2.335.011 3.934 2.365 1.566.005 1.574-3.936-.776-3.931.799-.005-1.574 2.356-1.58z" /></svg>;
export default SvgCommonAirTrack;